import ErrorPage from '../components/ErrorPage.jsx';

import { ErrorBoundary } from "@sentry/react";
import ContentPage from '../components/ContentPage.jsx';
import { useQuery } from '@tanstack/react-query';
import { getDatasources } from '../api/Datasources.js';

function LegalDataPage() {
  const datasourcesQuery = useQuery({
    queryKey: ['datasources'],
    queryFn: getDatasources,
    refetchInterval: false,
  });

  return (
    <ErrorBoundary fallback={ErrorPage}>
      <ContentPage title={'Data Accuracy and Attribution'}>
        <>
          <p>
            The meteorological data, observations and forecasts provided by Townsville.Today are gathered from a variety
            of <a href="#data-sources">reputable sources</a>, stored and processed on our own servers to provide the
            data and visualisations we display. We strive for accuracy and timeliness of information, and
            in most cases information is collated by our systems within minutes of publishing by a data provider.
            However, the nature of meteorological forecasting, automated data collection and fully-automated electronic
            transmission of this data means that the quality, accuracy and timeliness of the data cannot be guaranteed.
          </p>
          <p>
            Delays or disruptions due to technical problems, system limitations, data transmission issues, or
            environmental factors may impact the availability of data without notice. The forecasts provided by our
            data partners are based on predictive models that involve assumptions and estimations, and while they
            provide valuable guidance, they are not infallible and cannot be considered accurate. Variability in
            weather systems also means that local conditions may differ from what is shown on the platform. The
            information provided by Townsville.Today may include data which is not quality controlled or validated
            and may include errors or inaccuracies.
          </p>
          <p>
            <strong>Do not rely solely on the observations, forecasts, warnings or alerts on this platform for decision-making
            where safety, health, property protection or significant financial outcomes are involved.</strong> Always consult
            official sources such as the <a href="https://reg.bom.gov.au">Bureau of Meteorology</a>, the{' '}
            <a href="https://disaster.townsville.qld.gov.au/">Townsville Disaster Dashboard</a>, local emergency
            services for information and advice.
          </p>
          <h2 id="data-sources">Data Sources</h2>
          <p>
            The data displayed on Townsville.Today is sourced, under licence, from a variety of providers.
            Townsville.Today is not affiliated with any of the data providers listed below and use of their data does
            not imply any endorsement by the provider.
          </p>
          <p>
            Data Providers:
          </p>
          {datasourcesQuery.isLoading && <div className="m-4 text-dark">Loading...</div>}
          {datasourcesQuery.isError && <div className="m-4 text-dark">Error loading data sources</div>}
          <ul>
            {datasourcesQuery?.data?.map((source) => (
              <li key={source.key}>
                <a href={source.url}>{source.name}</a>
              </li>
            ))}
          </ul>
        </>
      </ContentPage>
    </ErrorBoundary>
  );
}

export default LegalDataPage
